export const isChannelLongTail = (channel) => channel.startsWith('LT');
